import { SdkThunkDispatch } from "@payping/redux/reducers";
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import { AppStoreStates } from "@/redux/configs";

export function useAppDispatch(): SdkThunkDispatch<AppStoreStates> {
  return useDispatch<SdkThunkDispatch<AppStoreStates>>();
}

export const useAppSelector: TypedUseSelectorHook<AppStoreStates> = useSelector;
